import { Routes, RouterModule } from "@angular/router";
import { ModuleWithProviders } from "@angular/core";
import { PagesComponent } from "./pages/pages.component";
import { BlankComponent } from "./pages/blank/blank.component";
import { NotFoundComponent } from "./pages/errors/not-found/not-found.component";
import { ErrorComponent } from "./pages/errors/error/error.component";
import { EquipmentListComponent } from "./pages/equipment/equipment-list/equipment-list.component";
import { AuthGuard } from "./auth.guard";
import { LocationListComponent } from "./pages/location-list/location-list.component";
import { CustomerSearchComponent } from "./pages/customer-search/customer-search.component";
import { SummaryComponent } from "./pages/summary/summary.component";
import { AccountDetailsComponent } from "./pages/account-details";
import { ContactUsComponent } from "./pages/contact-us/contact-us.component";
import { ContractsComponent } from "./pages/contracts/contracts.component";
import { TransactionsComponent } from "./pages/transactions/transactions.component";
import { MakeAPaymentComponent } from "./pages/aps";
import { PrebuyComponent } from "./pages/prebuy/prebuy.component";
import { RegisterComponent } from "./pages/register/register.component";
import { SetPasswordComponent } from "./pages/set-password/set-password.component";
import { ForgotPasswordComponent } from "./pages/forgot-password/forgot-password.component";
import { ImagingComponent } from "./pages/imaging/imaging.component";
import { ExternalLoginComponent } from "./pages/external-login/external-login.component";

export const routes: Routes = [

    { path: "", loadChildren: () => import("./pages/login/login.module").then(m => m.LoginModule) },
    { path: "company", loadChildren: () => import("./pages/login/login.module").then(m => m.LoginModule), data: { isCompany: true } },
    {
        path: "",
        component: PagesComponent, children: [
            { path: "home", component: SummaryComponent, data: { breadcrumb: "Summary" }, canActivate: [AuthGuard] },
            { path: "account-details", component: AccountDetailsComponent, data: { breadcrumb: "My Account" }, canActivate: [AuthGuard] },
            { path: "blank", component: BlankComponent, data: { breadcrumb: "Blank page" }, canActivate: [AuthGuard] },
            { path: "equipment", component: EquipmentListComponent, data: { breadcrumb: "Equipment" }, canActivate: [AuthGuard] },
            { path: "location", component: LocationListComponent, data: { breadcrumb: "Locations" }, canActivate: [AuthGuard] },
            { path: "customer-search", component: CustomerSearchComponent, data: { breadcrumb: "Customer Search" }, canActivate: [AuthGuard] },
            { path: "contact-us", component: ContactUsComponent, data: { breadcrumb: "Contact Us" }, canActivate: [AuthGuard] },
            { path: "contracts", component: ContractsComponent, data: { breadcrumb: "Contracts" }, canActivate: [AuthGuard] },
            { path: "transactions", component: TransactionsComponent, data: { breadcrumb: "Transactions" }, canActivate: [AuthGuard] },
            { path: "make-a-payment", component: MakeAPaymentComponent, data: { breadcrumb: "Make A Payment" }, canActivate: [AuthGuard] },
            { path: "prebuy", component: PrebuyComponent, data: { breadcrumb: "Prebuy Setup" }, canActivate: [AuthGuard] },
            { path: "documents", component: ImagingComponent, data: { breadcrumb: "Documents" }, canActivate: [AuthGuard] }
        ]
    },
    { path: "register", component: RegisterComponent, data: { breadcrumb: "Register" } },
    { path: "forgot-password", component: ForgotPasswordComponent, data: { custId: "" } },
    { path: "external-login", component: ExternalLoginComponent, data: { custId: "" } },
    { path: "set-password", component: SetPasswordComponent, data: { breadcrumb: "Password" }, canActivate: [AuthGuard] },
    { path: "error", component: ErrorComponent, data: { breadcrumb: "Error" } },
    { path: "**", component: NotFoundComponent, canActivate: [AuthGuard] },

];

export const routing: ModuleWithProviders<any> = RouterModule.forRoot(routes, {
    // preloadingStrategy: PreloadAllModules,  // <- uncomment this line for disable lazy load
    // enableTracing: true
    // useHash: true
});
